var _rect, _path, _path2, _polygon, _path3, _path4, _polygon2, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHongKong = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4,
    width: 30,
    height: 24,
    rx: 4,
    ry: 4,
    fill: "#db362f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z",
    opacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z",
    fill: "#fff",
    opacity: 0.2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "17.303 9.577 17.303 9.577 17.303 9.577 17.303 9.577",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.303,9.577c-1.568-.243-3.097,.628-3.687,2.101-.7,1.748,.149,3.732,1.897,4.432-.159-.143-.23-.35-.313-.547-.314-.742,.033-1.598,.775-1.911,.092-.039,.181-.086,.264-.14,.79-.513,1.014-1.568,.501-2.358-.051-.078-.091-.163-.12-.253-.177-.554,.128-1.147,.682-1.325Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.319,12.819c-1.879-.126-3.504,1.295-3.629,3.174,.087-.195,.262-.327,.423-.467,.609-.528,1.53-.462,2.058,.147,.065,.076,.137,.145,.215,.208,.732,.592,1.805,.48,2.398-.252,.059-.073,.127-.137,.203-.192,.472-.34,1.131-.233,1.471,.239-.253-1.567-1.554-2.751-3.138-2.857Z",
    fill: "#fff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "22.457 15.676 22.457 15.676 22.457 15.676 22.457 15.676",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.783,16.324c.044,.209-.02,.419-.068,.627-.182,.785-.966,1.273-1.751,1.091-.097-.023-.197-.037-.296-.042-.94-.049-1.742,.673-1.792,1.613-.005,.093-.022,.186-.052,.275-.182,.553-.778,.853-1.33,.671,1.126,1.119,2.875,1.312,4.218,.467,1.594-1.003,2.073-3.107,1.07-4.701Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.997,18.596c-.461-1.826-2.315-2.932-4.14-2.471,.212,.022,.392,.148,.575,.258,.69,.416,.912,1.312,.496,2.002-.052,.086-.096,.176-.131,.269-.337,.879,.102,1.865,.98,2.202,.087,.034,.17,.079,.245,.134,.469,.344,.571,1.003,.227,1.473,1.412-.725,2.136-2.329,1.748-3.867Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.954,16.445c-.803,.069-1.509-.525-1.578-1.328-.009-.1-.026-.198-.052-.295-.244-.909-1.178-1.449-2.088-1.205-.09,.024-.184,.036-.277,.036-.582-.003-1.051-.476-1.049-1.058h0c-.716,1.416-.36,3.14,.859,4.156,1.446,1.206,3.596,1.011,4.802-.435-.185,.107-.404,.111-.617,.129Z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHongKong);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/HongKong.abaa0a547ea90e04bafd048972b285e1.svg";